import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Optional, Inject, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { convertToNgbDate, datePickerMinDate, noWhitespaceInRequiredValidator } from '../../../shared/constants';
import { noop } from 'jquery';
import { NavbarComponent } from '../../../navbar/navbar.component';
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { catchError, map, of, startWith, switchMap, timer } from 'rxjs';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { addDays } from 'date-fns';

@Component({
	selector: 'app-roaster-form',
	templateUrl: './roaster-form.component.html',
	styleUrl: './roaster-form.component.scss'
})
export class RoasterFormComponent {
	File_Storage_URL = environment.File_Storage_URL;
	isDate(value) {
		return Object.prototype.toString.call(value) === '[object Date]';
	}
	fromToValidator: ValidatorFn = grp => {
		const from = grp.get('from_date')!.value;
		const to = grp.get('to_date')!.value;
		if (!from || !to || !this.isDate(from) || !this.isDate(to)) {
			return null
		};
		if (from.getDay() != 1) {
			return { invalidFromDate: true };
		}
		const jsFrom = from;
		const expectedTo = new Date(jsFrom);
		expectedTo.setDate(jsFrom.getDate() + (7 - jsFrom.getDay()));
		return to.getFullYear() === expectedTo.getFullYear() && to.getMonth() === expectedTo.getMonth() && to.getDate() === expectedTo.getDate() ? null : { invalidToDate: true };
	}
	moduleForm: FormGroup = this.formBuilder.group({
		emp_code: [null, [Validators.required]],
		from_date: [null, [Validators.required]],
		to_date: [{ value: null, disabled: true }, [Validators.required]],
		line_items: this.formBuilder.array([])
	}, { validators: this.fromToValidator });
	showLoader = false;
	pageLoading1 = false;
	uId: any = null;
	@Input() userList: any[] = [];
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	formSubmitted = false;
	details: any = null;
	minDate = datePickerMinDate;
	minDateInRow: any = null;
	maxDateInRow: any = null;
	deleted_items: any[] = [];
	modalId = "roasterModal" + this.getRandom5DigitNumber();
	getRandom5DigitNumber() {
		return Math.floor(Math.random() * 90000) + 10000;
	}

	constructor(private calendar: NgbCalendar, private cd: ChangeDetectorRef, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.f.from_date.valueChanges.pipe(startWith(this.f.from_date.value)).subscribe(_ => this.onFromDateSelect());
		this.f.to_date.valueChanges.pipe(startWith(this.f.to_date.value)).subscribe(_ => this.onToDateSelect());
	}

	initForm(obj: any) {
		this.uId = obj?.id || null;
		if (this.uId) {
			this.details = obj;
			this.bindDetails(true);
		} else {
			this.resetForm();
			if (obj?.emp_code) {
				this.f.emp_code.setValue(obj?.emp_code);
			}
			this.formSubmitted = false;
			this.uId = null;
		}
		if (!this.navbar.user.tms_access?.roaster_module) {
			this.f.emp_code.disable();
		} else {
			this.f.emp_code.enable();
		}
		this.openModal();
	}

	fetchForCopyLoader = false
	fetchForCopy() {
		if (!this.f.emp_code.value) {
			this.toastr.error("Please select employee", 'Employee', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.fetchForCopyLoader = true;
		this.apiService.getLastRoasterByEmpCode({ emp_code: this.f.emp_code.value }).subscribe({
			next: (data: any) => {
				this.fetchForCopyLoader = false;
				this.details = data.data;
				this.bindDetails(false);
				this.cd.detectChanges();
			}, error: (error) => {
				this.fetchForCopyLoader = false;
				this.cd.detectChanges();
				if (error.status == 401) { return }
				let errorMsg = error.error;
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	bindDetails(isEdit: boolean) {
		let daysToAdd = 0;
		if (!isEdit) {
			daysToAdd = 7;
		}
		if (this.details.emp_code.emp_code) {
			this.navbar.getValueFromUserList(this.details.emp_code.emp_code, "emp_code").then((val) => {
				this.f.emp_code.setValue(val);
			});
		}
		this.f.from_date.setValue(addDays(this.apiService.getDateFromDateString(this.details.from_date, 'DD-MM-YYYY'), daysToAdd), { emitEvent: false });
		this.f.to_date.setValue(addDays(this.apiService.getDateFromDateString(this.details.to_date, 'DD-MM-YYYY'), daysToAdd));
		let line_items: any = this.details.line_items;
		let len = line_items.length;
		for (let i = 0; i < len; i++) {
			this.addRow();
			this.get_rows.controls[i].get("id")?.setValue(line_items[i].id);
			this.get_rows.controls[i].get("in_date")?.setValue(addDays(this.apiService.getDateFromDateString(line_items[i].in_date, 'DD-MM-YYYY'), daysToAdd));
			this.get_rows.controls[i].get("in_time")?.setValue(this.apiService.getTimeFromTimeString(line_items[i].in_time));
			this.get_rows.controls[i].get("out_date")?.setValue(addDays(this.apiService.getDateFromDateString(line_items[i].out_date, 'DD-MM-YYYY'), daysToAdd));
			this.get_rows.controls[i].get("out_time")?.setValue(this.apiService.getTimeFromTimeString(line_items[i].out_time));
		}
	}

	public fromDateDisabled = (d: NgbDate) => {
		return this.calendar.getWeekday(d) !== 1
	};

	onFromDateSelect() {
		const from_date = this.f.from_date.value;
		if (!from_date || !this.isDate(from_date)) {
			return;
		}
		this.minDateInRow = convertToNgbDate(from_date)
		const jsDate = new Date(from_date);
		const jsSunday = new Date(from_date);
		jsSunday.setDate(jsDate.getDate() + (7 - jsDate.getDay()));
		this.moduleForm.patchValue({
			to_date: jsSunday
		});
		this.autoCreateRows();
	}

	onToDateSelect() {
		const to_date = this.f.to_date.value;
		if (!to_date || !this.isDate(to_date)) {
			return;
		}
		this.maxDateInRow = convertToNgbDate(addDays(new Date(to_date), 1));
	}

	autoCreateRows() {
		const from_date = this.f.from_date.value;
		const to_date = this.f.to_date.value;
		if (
			!this.uId &&
			/* !this.details && */
			from_date &&
			this.isDate(from_date) &&
			to_date &&
			this.isDate(to_date)
		) {
			this.get_rows.clear();
			let marker = new Date(from_date);
			for (let i = 0; i < 7; i++) {
				this.addRow();
				this.get_rows.controls[i].get("in_date")?.setValue(new Date(marker));
				this.get_rows.controls[i].get("out_date")?.setValue(new Date(marker));
				marker = addDays(marker, 1);
			}
		}
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['line_items'] as FormArray;
	}

	addRow() {
		const form = this.formBuilder.group({
			id: [null],
			in_date: [null, [Validators.required], this.leaveValidation()],
			in_time: [null, [Validators.required]],
			out_date: [null, [Validators.required]],
			out_time: [null, [Validators.required]]
		});
		this.get_rows.push(form);
	}

	deleteRow(index: number) {
		let id = this.get_rows.controls[index].get("id")?.value;
		if (id) {
			this.deleted_items.push(id);
		}
		this.get_rows.at(index).markAsUntouched();
		this.get_rows.at(index).updateValueAndValidity();
		this.get_rows.removeAt(index);
	}

	leaveValidation = (time: number = 500) => {
		return (input: FormControl) => {
			return timer(time).pipe(switchMap(() => this.apiService.checkLeave(this.getPayloadForLeaveValidation(input.value))),
				map(res => {
					return null;
				}), catchError((e) => {
					return of({ leave: true });
				})
			);
		};
	};

	getPayloadForLeaveValidation(date: any) {
		return {
			emp_code: this.f.emp_code.value,
			date: this.apiService.getDateStringFromDate(date, 'YYYY-MM-DD')
		}
	}

	clearForm() {
		this.uId = null;
		this.resetForm();
		this.formSubmitted = false;
		this.cleared.emit();
		$("#" + this.modalId).modal("hide");
	}

	resetForm() {
		this.get_rows.clear();
		this.moduleForm.reset();
		this.deleted_items = [];
	}

	openModal() {
		$("#" + this.modalId).modal("show");
	}

	saveData() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			emp_code: this.f.emp_code.value,
			from_date: this.apiService.getDateStringFromDate(this.f.from_date.value, 'YYYY-MM-DD'),
			to_date: this.apiService.getDateStringFromDate(this.f.to_date.value, 'YYYY-MM-DD'),
			deleted_items: this.deleted_items
		};
		let line_items: any = [];
		let len = this.get_rows.controls.length;
		if (!len) {
			this.toastr.info("Please add rows", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		for (let i = 0; i < len; i++) {
			let line_item: any = {
				in_date: this.apiService.getDateStringFromDate(this.get_rows.controls[i].get("in_date")?.value, 'YYYY-MM-DD'),
				in_time: this.apiService.getTimeStringFromTime(this.get_rows.controls[i].get("in_time")?.value),
				out_date: this.apiService.getDateStringFromDate(this.get_rows.controls[i].get("out_date")?.value, 'YYYY-MM-DD'),
				out_time: this.apiService.getTimeStringFromTime(this.get_rows.controls[i].get("out_time")?.value),
			}
			let id = this.get_rows.controls[i].get("id")?.value;
			if (id) {
				line_item["id"] = id;
			}
			line_items.push(line_item);
		}
		data.line_items = line_items;
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateRoaster(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.cd.detectChanges();
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				this.cd.detectChanges();
				if (error.status == 401) { return }
				let errorMsg = error.error;
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}
}
